import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "payment-details" }
const _hoisted_2 = { class: "col--12" }
const _hoisted_3 = { class: "col--12" }
const _hoisted_4 = { class: "col--8" }
const _hoisted_5 = { class: "col--4" }
const _hoisted_6 = {
  key: 0,
  class: "col--12"
}
const _hoisted_7 = { class: "grand-total col--12" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 1,
  class: "col--12"
}
const _hoisted_11 = {
  key: 0,
  class: "close"
}
const _hoisted_12 = {
  key: 1,
  class: "open"
}
const _hoisted_13 = { class: "info-box" }
const _hoisted_14 = { class: "button-container col--12" }
const _hoisted_15 = ["action"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BookingHeader = _resolveComponent("BookingHeader")!
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_BaseInput = _resolveComponent("BaseInput")!
  const _component_BaseAlert = _resolveComponent("BaseAlert")!
  const _component_BaseSvg = _resolveComponent("BaseSvg")!
  const _component_BookingBasket = _resolveComponent("BookingBasket")!
  const _component_BaseExpansion = _resolveComponent("BaseExpansion")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseSection = _resolveComponent("BaseSection")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BookingHeader, {
      title: _ctx.$t('payment.title'),
      subtitle: _ctx.$t('payment.subtitle')
    }, null, 8, ["title", "subtitle"]),
    _createVNode(_component_BaseSection, { class: "payment-details__container" }, {
      default: _withCtx(() => [
        (_ctx.initializing)
          ? (_openBlock(), _createBlock(_component_BaseSpinner, {
              key: 0,
              size: 40
            }))
          : (_openBlock(), _createElementBlock("form", {
              key: 1,
              onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.forward && _ctx.forward(...args)), ["prevent"])),
              class: "row"
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_BaseInput, {
                  label: _ctx.$t('payment.card.holder'),
                  placeholder: _ctx.$t('payment.card.holder'),
                  hasError: _ctx.v$.name.$error,
                  errors: _ctx.v$.name.$errors,
                  valid: !_ctx.v$.name.$invalid,
                  modelValue: _ctx.v$.name.$model,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.name.$model) = $event)),
                  name: "name"
                }, null, 8, ["label", "placeholder", "hasError", "errors", "valid", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _withDirectives(_createVNode(_component_BaseInput, {
                  label: _ctx.$t('payment.card.number'),
                  placeholder: _ctx.$t('payment.card.number'),
                  hasError: _ctx.v$.cardNumber.$error,
                  errors: _ctx.v$.cardNumber.$errors,
                  valid: !_ctx.v$.cardNumber.$invalid,
                  modelValue: _ctx.v$.cardNumber.$model,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.cardNumber.$model) = $event)),
                  name: "cardNumber"
                }, null, 8, ["label", "placeholder", "hasError", "errors", "valid", "modelValue"]), [
                  [_directive_maska, '#### #### #### ####']
                ])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _withDirectives(_createVNode(_component_BaseInput, {
                  label: _ctx.$t('payment.card.expiryDate'),
                  placeholder: _ctx.$t('payment.card.expiryDate'),
                  hasError: _ctx.v$.expiryDate.$error,
                  errors: _ctx.v$.expiryDate.$errors,
                  valid: !_ctx.v$.expiryDate.$invalid,
                  modelValue: _ctx.v$.expiryDate.$model,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.expiryDate.$model) = $event)),
                  name: "epiration"
                }, null, 8, ["label", "placeholder", "hasError", "errors", "valid", "modelValue"]), [
                  [_directive_maska, '##/##']
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _withDirectives(_createVNode(_component_BaseInput, {
                  label: _ctx.$t('payment.card.CVC'),
                  placeholder: _ctx.$t('payment.card.CVC'),
                  hasError: _ctx.v$.cvc.$error,
                  errors: _ctx.v$.cvc.$errors,
                  valid: !_ctx.v$.cvc.$invalid,
                  modelValue: _ctx.v$.cvc.$model,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.cvc.$model) = $event)),
                  name: "cvc"
                }, null, 8, ["label", "placeholder", "hasError", "errors", "valid", "modelValue"]), [
                  [_directive_maska, '####']
                ])
              ]),
              (_ctx.errors.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_BaseAlert, {
                      type: "danger",
                      message: _ctx.errors.join(', ')
                    }, null, 8, ["message"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.$t('payment.grandTotal')), 1),
                (_ctx.bookingSummary.totalPrice > 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.bookingSummary.currency) + " " + _toDisplayString(_ctx.bookingSummary.leftToPay.toFixed(2)), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_9, "-"))
              ]),
              (!_ctx.bookingSummary.isAccommodation)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("a", {
                      class: _normalizeClass(["toggle", { opened: _ctx.showBasket }]),
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleBasket && _ctx.toggleBasket(...args)))
                    }, [
                      (_ctx.showBasket)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$t('payment.hideDetails')), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$t('payment.showDetails')), 1)),
                      _createVNode(_component_BaseSvg, { icon: 'chevron/chevron-dropdown-down' })
                    ], 2),
                    _createVNode(_component_BaseExpansion, {
                      expanded: _ctx.showBasket,
                      class: "basket-container"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_BookingBasket, { renderBasketContainer: false })
                      ]),
                      _: 1
                    }, 8, ["expanded"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_BaseAlert, {
                  type: "warning",
                  title: "Payment update"
                }, {
                  default: _withCtx(() => _cache[11] || (_cache[11] = [
                    _createTextVNode(" Our booking pages have been updated to facilitate added security measures when making payments online. You may be asked to take extra verification steps at the checkout. In some cases, this may require prior set up with your bank. ")
                  ])),
                  _: 1,
                  __: [11]
                })
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_BaseButton, { loading: _ctx.loading }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('payment.confirm')), 1)
                  ]),
                  _: 1
                }, 8, ["loading"]),
                (_ctx.bookingSummary.isAccommodation)
                  ? (_openBlock(), _createBlock(_component_BaseButton, {
                      key: 0,
                      onClick: _withModifiers(_ctx.cancelAccommodationBooking, ["stop"]),
                      loading: _ctx.loading,
                      disabled: _ctx.loading,
                      class: "button--transparent"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("button.cancel")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick", "loading", "disabled"]))
                  : (_openBlock(), _createBlock(_component_BaseButton, {
                      key: 1,
                      type: "button",
                      onClick: _ctx.prevStep,
                      class: "button--white"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('nav.goBack')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
              ])
            ], 32))
      ]),
      _: 1
    }),
    (_ctx.payResult)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          method: "post",
          id: "threeDSecureForm",
          action: _ctx.payResult.url,
          ref: "threeDSecureForm"
        }, [
          (_ctx.payResult.cReq)
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 0,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.payResult.cReq) = $event)),
                type: "hidden",
                name: "creq"
              }, null, 512)), [
                [_vModelText, _ctx.payResult.cReq]
              ])
            : _createCommentVNode("", true),
          (_ctx.payResult.threeDSSessionData)
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.payResult.threeDSSessionData) = $event)),
                type: "hidden",
                name: "threeDSSessionData"
              }, null, 512)), [
                [_vModelText, _ctx.payResult.threeDSSessionData]
              ])
            : _createCommentVNode("", true),
          (_ctx.payResult.paReq)
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 2,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.payResult.paReq) = $event)),
                type: "hidden",
                name: "PaReq"
              }, null, 512)), [
                [_vModelText, _ctx.payResult.paReq]
              ])
            : _createCommentVNode("", true),
          (_ctx.payResult.paReq)
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 3,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.payResult.successUrl) = $event)),
                type: "hidden",
                name: "TermUrl"
              }, null, 512)), [
                [_vModelText, _ctx.payResult.successUrl]
              ])
            : _createCommentVNode("", true),
          (_ctx.payResult.paReq)
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 4,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.payResult.threeDSSessionData) = $event)),
                type: "hidden",
                name: "MD"
              }, null, 512)), [
                [_vModelText, _ctx.payResult.threeDSSessionData]
              ])
            : _createCommentVNode("", true)
        ], 8, _hoisted_15))
      : _createCommentVNode("", true)
  ]))
}